// store.ts
import { config } from '@/config';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session'; // Lưu vào sessionStorage
import { apiCaller } from './query';
import authSlice from './slice/auth.slice';
import bannerSlice from './slice/banner.slice';
import dashboardSlice from './slice/Dashboard/dashboard.slice';
import previewSlice from './slice/preview.slice';
import translationSlice from './slice/translation.slice';
import toastSlice from './slice/Toast/toast.slice';
import contextualBarSlice from './slice/contextualBar.slice';
import checkoutVerificationSlice from './slice/checkoutVerification.slice';
import termAndConditionSlice from './slice/termAndCondition.slice';
import sessionSlice from './slice/session.slice';
import shopSlice from './slice/shop.slice';
import pricingSlice from './slice/pricing.slice';
import { apiAdminCaller } from './query/admin';

const termAndConditionPersistConfig = {
  key: `${config.shop}-termAndCondition`,
  storage: storageSession,
  whitelist: ['termAndConditionType'], // Chỉ lưu trạng thái termAndConditionType
};

const bannerPersistConfig = {
  key: `${config.shop}-banner`,
  storage: storageSession,
};

const authPersistConfig = {
  key: 'auth',
  storage: storageSession,
};

const sessionPersistConfig = {
  key: `${config.shop}-session`,
  storage: storageSession,
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authSlice.reducer),
  toast: toastSlice.reducer,
  preview: previewSlice.reducer,
  translation: translationSlice.reducer,
  dashboard: dashboardSlice.reducer,
  banner: persistReducer(bannerPersistConfig, bannerSlice.reducer),
  apiCaller: apiCaller.reducer,
  contextualBar: contextualBarSlice.reducer,
  checkoutVerification: checkoutVerificationSlice.reducer,
  termAndCondition: persistReducer(termAndConditionPersistConfig, termAndConditionSlice.reducer), // Áp dụng persist cho termAndConditionSlice
  sessionStorage: persistReducer(sessionPersistConfig, sessionSlice.reducer),
  shop: shopSlice.reducer,
  pricing: pricingSlice.reducer,
  apiAdminCaller: apiAdminCaller.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const customizedMiddleware = getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    });
    return customizedMiddleware.concat(apiCaller.middleware, apiAdminCaller.middleware);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const persistor = persistStore(store);
export default store;
